import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'header-modal',
  templateUrl: './header-modal.component.html',
  styleUrls: ['./header-modal.component.scss'],
})
export class HeaderModalComponent implements OnInit {
  @Input() title: string = '';
  @Output() action = new EventEmitter<string>();
  constructor() {}

  ngOnInit(): void {}

  actions() {
    this.action.emit(this.title);
  }
}
